import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import USER_EXISTS from "../queries/getUserExists.gql";

const useUserExists = () => {
  const [loading, setLoading] = useState(false);
  const [getUserExists, { data, loading: queryLoading, errors }] = useLazyQuery(USER_EXISTS);

  useEffect(() => {
    if (data !== undefined && !queryLoading) {
      setLoading(false);
    }
  }, [data, queryLoading]);

  return {
    getUserExists: (email) =>
      new Promise((resolve) => {
        setLoading(true);
        resolve(getUserExists({ variables: { email } }));
      }),
    userExists: data?.userExists?.ok,
    errors,
    loading,
  };
};

export default useUserExists;
